import { apiRequest } from './auth';

export const employeesAPI = {
  getAll: async () => {
    return await apiRequest('/employees');
  },

  getByProject: async (project) => {
    return await apiRequest(`/employees/project/${encodeURIComponent(project)}`);
  },

  getById: async (id) => {
    return await apiRequest(`/employees/${id}`);
  },

  create: async (employeeData) => {
    return await apiRequest('/employees', {
      method: 'POST',
      body: JSON.stringify(employeeData),
    });
  },

  update: async (id, employeeData) => {
    return await apiRequest(`/employees/${id}`, {
      method: 'PUT',
      body: JSON.stringify(employeeData),
    });
  },

  delete: async (id) => {
    return await apiRequest(`/employees/${id}`, {
      method: 'DELETE',
    });
  }
};

export default employeesAPI;
